export default __webpack_public_path__ + "static/media/My_Path_Lock.dcd1db02.jpg";